module.exports = __webpack_public_path__ + "img/png.6d55b7fc.svg";